<template>
  <a-dialog v-model="show" persistent max-width="800px" scrollable>
    <v-card>
      <v-toolbar color="primaryLight1" sticky single-line tile>
        <v-btn icon large>
          <v-icon v-if="!Edit">mdi-account-plus</v-icon>
          <v-icon v-if="Edit">mdi-account-edit</v-icon>
        </v-btn>
        <span>{{ $t("admin.roleSettings") }}</span>
        <v-spacer></v-spacer>
        <CloseIcon @click="close()" />
      </v-toolbar>

      <v-card-text>
        <v-form ref="refRollForm" v-model="valid" lazy-validation @submit.prevent>
          <v-container style="padding: 0 !important">
            <v-row>
              <v-col cols="12" md="12" v-if="!Edit" class="pb-0">
                <a-text-field
                  class="textField"
                  v-if="!Edit"
                  v-model="roleForm.role"
                  :label="$t('admin.role')"
                  :requiredMessage="$t('ruleMandatory')"
                  required
                  @input="checkUniqueRoleName"
                  @keydown.enter.prevent
                  filled
                  :readonly="isUsed"
                  :hide-details="isUsed || isRoleNameExist"
                ></a-text-field>
                <span v-if="isUsed" class="red--text">{{
                  $t("admin.assignedRoleMessage")
                }}</span>
              </v-col>
              <v-col cols="12" md="12" v-if="Edit" class="pb-0">
                <a-text-field
                  v-if="Edit"
                  v-model="roleForm.role"
                  :label="$t('admin.role')"
                  :requiredMessage="$t('ruleMandatory')"
                  :readonly="isUsed || Edit"
                  @keydown.enter.prevent
                  dense
                  filled
                  :hide-details="isUsed || isRoleNameExist"
                ></a-text-field>
              </v-col>
              <v-col
                v-if="isRoleNameExist"
                cols="12"
                no-gutters
                class="pt-0 pb-0"
              >
                <span style="color: var(--v-error-base); ma">{{
                  this.$t("admin.msgRoleUnique")
                }}</span>
              </v-col>
              <v-col cols="12" md="12" class="pt-0">
                <module-permission
                  v-model="roleForm.permissions"
                  :permissionsList="permissionsList"
                ></module-permission>
                <v-alert
                  v-if="roleForm.permissions.length < 1"
                  dense
                  type="error"
                  class="mx-auto mt-3 mb-0"
                >
                  {{ this.$t("poll.ruleSelectOneItem") }}
                </v-alert>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <a-btn
              v-bind="attrs"
              v-on="on"
              color="primaryDark"
              :disabled="saveDisabled || isDirtyData"
              @click="SaveRole()"
              >{{ $t("btnSave") }}</a-btn
            >
          </template>
          <span>{{ $t("btnSave") }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <a-btn
              v-bind="attrs"
              v-on="on"
              class="ml-2"
              color="secondary"
              @click="close()"
              >{{ $t("btnClose") }}</a-btn
            >
          </template>
          <span>{{ $t("btnClose") }}</span>
        </v-tooltip>
      </v-card-actions>
      <prevent-confirmation
        :prevent="isPrevent"
        @save="SaveRole"
        @discard="preventClose(true)"
        @cancel="preventClose(false)"
      >
      </prevent-confirmation>
    </v-card>
  </a-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";
import ModulePermission from "./ModulePermission.vue";
import RolePermission from "./RolePermission.vue";
import ADialog from "../../wrapper-component/ADialog.vue";
import ABtn from "../../wrapper-component/ABtn.vue";
import PreventConfirmation from "../PreventConfirmation.vue";
import { cloneDeep } from "lodash";
export default {
  components: {
    RolePermission,
    ModulePermission,
    ADialog,
    ABtn,
    PreventConfirmation,
  },
  name: "AddRoles",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    permissionsList: {
      type: Array,
      default: () => [],
    },
    data: Object,
    formData: Object,
  },
  data() {
    return {
      isHideDetails: false,
      isRoleNameExist: false,
      valid: true,
      Edit: false,
      isPrevent: false,
      originalRoleName: this.data.role,
      rules: [
        (v) => !!v || this.$t("ruleMandatory"),
        (v) => /[a-zA-Z]/.test(v),
        (v) =>
          !(v && this.checkUniqueRoleName(v)) || this.$t("admin.msgRoleUnique"),
      ],
    };
  },
  computed: {
    ...mapState({
      roleList: (state) => state.admin.roleList,
      userList: (state) => state.admin.userList,
    }),
    LoaderText() {
      return this.$t("SaveLoader");
    },
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || false);
      },
    },
    roleForm() {
      return this.data;
    },
    isUsed() {
      if (!this.data.id) {
        return false;
      }
      const index = this.userList.findIndex((item) => {
        return item.roles.includes(this.data.role);
      });
      //console.log(this.userList[index]);
      return index !== -1 ? true : false;
    },
    saveDisabled(val) {
      // return !this.valid;
      return !this.roleForm.role || this.roleForm.permissions.length < 1;
    },
    isDirtyData() {

      const formData = cloneDeep(this.formData)
      formData.permissions = formData.permissions.sort((a, b) => a.localeCompare(b));

      const roleForm = cloneDeep(this.roleForm)
      roleForm.permissions = roleForm.permissions.sort((a, b) => a.localeCompare(b));

      return JSON.stringify(formData) === JSON.stringify(roleForm);
    },
    isFormChanged() {
      const formdata = {
        role: this.formData ? this.formData.role : "",
        permissions: this.formData ? this.formData.permissions : [],
      };
      const roleForm = {
        role: this.roleForm.role,
        permissions: this.roleForm ? this.roleForm.permissions : [],
      };
      return JSON.stringify(formdata) !== JSON.stringify(roleForm);
    },
  },
  methods: {
    ...mapActions({
      createRole: "admin/createRole",
      updateRole: "admin/updateRole",
    }),
    SaveRole,
    close,
    addRole,
    updateRoleDetails,
    reset,
    checkUniqueRoleName,
    closeAfterSave,
    preventClose(status) {
      this.isPrevent = false;
      if (status) {
        this.$emit("input", false);
        // this.isDirty = false;
      }
    },
  },
};

function checkUniqueRoleName(roleName) {
  this.isHideDetails = false;
  if (this.$refs.refRollForm.validate()) {
    this.isHideDetails = true;
  }
  if (
    this.$refs.refRollForm.validate() &&
    String(this.originalRoleName).toLowerCase() !==
      String(roleName).toLowerCase()
  ) {
    this.isHideDetails = true;
    this.isRoleNameExist = this.roleList
      .filter((r) => r.role_type === this.roleForm.role_type)
      .some(
        (r) => String(r.role).toLowerCase() === String(roleName).toLowerCase()
      );
  }
}

async function SaveRole() {
  this.isPrevent = false;
  try {
    if (this.$refs.refRollForm.validate() && !this.isRoleNameExist) {
      if (this.roleForm.id) {
        await this.updateRoleDetails().then((res) => {
          this.$emit("saveRoles");
        });
      } else {
        await this.addRole().then((res) => {
          this.$emit("saveRoles");
        });
      }
      this.closeAfterSave();
    }
  } catch (error) {
    console.log(error, "add  roles");
  }
}

async function addRole() {
  await this.createRole(this.roleForm);
}

async function updateRoleDetails() {
  await this.updateRole(this.roleForm);
}

function close() {
  if (this.isFormChanged) {
    this.isPrevent = true;
  } else {
    this.reset();
    this.$emit("input", false);
  }
}
function closeAfterSave() {
  this.reset();
  this.$emit("input", false);
}
function reset() {
  this.$refs.refRollForm.resetValidation();
  this.$refs.refRollForm.reset();
}
</script>

<style scoped>
.textField {
  font-family: "Noto Sans JP" !important;
  font-style: normal !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  line-height: 18px !important;
  min-height: 48px !important;
  max-height: 68px !important;
  color: var(--v-neutralGray-base) !important;
  align-items: center !important;
}
.textField > .v-input__control > .v-input__slot {
  color: var(--v-neutralGray-base) !important;
  height: 48px !important;
}
.textField /deep/ .v-input__slot {
  min-height: 48px !important;
}
</style>